import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ApplyConfirmPage } from '@/features/apply';

/** Target of the application confirmation email. */
export const Route = createFileRoute('/(public)/apply/confirm')({
  validateSearch: z.object({ token: z.string().optional() }),
  component: ApplyConfirmRoute,
});

function ApplyConfirmRoute() {
  const { token } = Route.useSearch();
  return <ApplyConfirmPage token={token} />;
}
